import React, { createContext, useContext, useState, useCallback } from 'react';

/* ═══════════════════════════════════════════════════
   Translation Dictionary — English & Hindi
   ═══════════════════════════════════════════════════ */

const translations = {
    en: {
        // Navbar
        nav_home: 'Home',
        nav_life: 'Life',
        nav_health: 'Health',
        nav_motor: 'Motor',
        nav_property: 'Property',
        nav_travel: 'Travel',
        nav_business: 'Business',
        nav_insurance: 'Insurance',
        nav_about: 'About Us',
        nav_contact: 'Contact',
        nav_get_started: 'Get Started',
        nav_search_placeholder: 'Search insurance plans...',
        nav_branch: 'New Delhi, India',
        nav_whatsapp: '+91 96671 93590',
        nav_phone: '+91 96671 93590',

        // Hero
        hero_badge: 'Top Rated · 2026',
        hero_title: 'Secure Your Future with Smart Insurance',
        hero_subtitle: 'Explore plans tailored for your life, health, and assets. Premium coverage at transparent prices with industry-leading claim settlements.',
        hero_trust: 'Trusted by 2,00,000+ happy policyholders',
        hero_btn_explore: 'Get a Quote',
        hero_btn_quote: 'Get Quote',

        // Stats
        stat_1_num: '2L+',
        stat_1_label: 'Happy Customers',
        stat_2_num: '99%',
        stat_2_label: 'Claim Settlement',
        stat_3_num: '₹500Cr+',
        stat_3_label: 'Claims Paid',
        stat_4_num: '50+',
        stat_4_label: 'Insurance Plans',

        // Products Section
        products_eyebrow: 'Our Products',
        products_title: 'Insurance Plans for Every Need',
        products_subtitle: 'Comprehensive coverage options designed to protect what matters most to you.',
        product_life: 'Life Insurance',
        product_life_desc: 'Secure your family\'s future with our comprehensive life insurance plans.',
        product_health: 'Health Insurance',
        product_health_desc: 'Quality healthcare coverage for you and your loved ones.',
        product_motor: 'Motor Insurance',
        product_motor_desc: 'Fast claim settlements and wide garage network for your vehicle.',
        product_property: 'Property Insurance',
        product_property_desc: 'Protect your home and assets with our property coverage.',
        product_travel: 'Travel Insurance',
        product_travel_desc: 'Travel the world with peace of mind and 24/7 assistance.',
        product_business: 'Business Insurance',
        product_business_desc: 'Safeguard your business against unforeseen risks.',
        product_others: 'Others',
        product_others_desc: 'Specialized insurance for your pets, gadgets, and more.',
        learn_more: 'Learn more',

        // How It Works
        hiw_eyebrow: 'Simple Process',
        hiw_title: 'How It Works',
        hiw_subtitle: 'Get covered in four simple steps — no paperwork, no hassle.',
        hiw_step1: 'Request Quote',
        hiw_step1_desc: 'Browse our wide range of insurance plans tailored for you.',
        hiw_step2: 'Get a Quote',
        hiw_step2_desc: 'Answer a few quick questions and get an instant quote.',
        hiw_step3: 'Apply Online',
        hiw_step3_desc: 'Complete your application in minutes — fully digital.',
        hiw_step4: 'Stay Protected',
        hiw_step4_desc: 'Relax knowing your future is secured from day one.',

        // Benefits
        benefits_eyebrow: 'Why InsureWise',
        benefits_title: 'Built on Trust & Transparency',
        benefits_subtitle: 'We go beyond policy documents to truly protect your peace of mind.',
        benefit_1: '99% Claim Settlement',
        benefit_1_desc: 'Industry-leading transparency and speed when it comes to claims processing.',
        benefit_2: '24/7 Customer Support',
        benefit_2_desc: 'Our dedicated advisors are always available to assist you — anytime, anywhere.',
        benefit_3: 'Paperless Process',
        benefit_3_desc: 'Get insured in minutes with our fully digital and seamless onboarding experience.',

        // Testimonials
        testimonials_eyebrow: 'Customer Stories',
        testimonials_title: 'What Our Customers Say',
        testimonials_subtitle: 'Real experiences from people who trust InsureWise with their future.',
        testimonial_1: 'InsureWise made getting health coverage incredibly simple. The entire process was digital and I had my policy within 10 minutes.',
        testimonial_1_name: 'Priya Sharma',
        testimonial_1_role: 'Health Plan Member',
        testimonial_2: 'Their 24/7 support team helped me through a motor claim at 2 AM. Exceptional service and fast settlement — truly impressed.',
        testimonial_2_name: 'Rahul Verma',
        testimonial_2_role: 'Motor Insurance',
        testimonial_3: 'As a business owner, finding the right coverage was daunting. InsureWise\'s advisors walked me through every option with patience.',
        testimonial_3_name: 'Anita Desai',
        testimonial_3_role: 'Business Insurance',

        // CTA
        cta_title: 'Ready to Protect What Matters?',
        cta_subtitle: 'Join 2 lakh+ customers who chose smarter insurance. Get a personalised quote in under 2 minutes.',
        cta_btn_primary: 'Get Started',
        cta_btn_secondary: 'Explore Plans',

        // Contact Page
        contact_hero_title: "We're Here to Help You",
        contact_hero_subtitle: "Have questions about our plans? Our experts are just a message away. Let's secure your future together.",
        contact_title: 'Get in Touch',
        contact_subtitle: 'Reach out through any of these channels or fill the form.',
        contact_email_title: 'Email Us',
        contact_call_title: 'Call Us',
        contact_visit_title: 'Visit Our Office',
        contact_hours_title: 'Office Hours',
        contact_hours_mf: 'Monday - Friday',
        contact_hours_sat: 'Saturday',
        contact_hours_sun: 'Sunday',
        contact_hours_mf_time: '9:00 AM - 6:00 PM',
        contact_hours_sat_time: '10:00 AM - 2:00 PM',
        contact_hours_sun_time: 'Closed',
        contact_form_name: 'Full Name',
        contact_form_email: 'Email Address',
        contact_form_phone: 'Phone Number',
        contact_form_subject: 'Subject',
        contact_form_message: 'How can we help?',
        contact_form_submit: 'Send Message',
        contact_form_sending: 'Sending...',
        contact_form_note: 'Our team typically responds within 4 working hours.',
        contact_form_placeholder_name: 'Enter your name',
        contact_form_placeholder_email: 'you@email.com',
        contact_form_placeholder_phone: '99999xxxxx',
        contact_form_placeholder_message: 'Tell us about your insurance needs...',
        contact_option_general: 'General Inquiry',
        contact_option_claims: 'Claims Support',
        contact_option_agent: 'Agent Consultation',
        contact_option_policy: 'Policy Update',
        contact_success_title: 'Message Sent!',
        contact_success_text: 'Thank you for reaching out. One of our insurance experts will contact you shortly.',
        contact_success_btn: 'Send Another Message',

        // Footer
        footer_brand_text: 'Providing premium insurance solutions since 1995. Your security is our priority.',
        footer_company: 'Company',
        footer_about: 'About Us',
        footer_careers: 'Careers',
        footer_contact: 'Contact Us',
        footer_blog: 'Blog',
        footer_insurance_types: 'Insurance Types',
        footer_support: 'Support',
        footer_copyright: '© {year} Bharatinsurex. All rights reserved.',

        // Extended Insurance Categories
        ft_life: 'Life Insurance',
        ft_life_term: 'Term Insurance',
        ft_life_whole: 'Whole Life Insurance',
        ft_life_endow: 'Endowment Plan',
        ft_life_money: 'Money Back Plan',
        ft_life_ulip: 'ULIP (Unit Linked Insurance Plan)',
        ft_life_child: 'Child Insurance Plan',
        ft_life_pension: 'Pension Plan',

        ft_health: 'Health Insurance',
        ft_health_indiv: 'Individual Health Insurance',
        ft_health_family: 'Family Floater Insurance',
        ft_health_critical: 'Critical Illness Insurance',
        ft_health_senior: 'Senior Citizen Health Insurance',
        ft_health_group: 'Group Health Insurance',
        ft_health_accident: 'Personal Accident Insurance',

        ft_motor: 'Motor Insurance',
        ft_motor_car: 'Car Insurance',
        ft_motor_bike: 'Two-Wheeler Insurance',
        ft_motor_comm: 'Commercial Vehicle Insurance',
        ft_motor_third: 'Third-Party Insurance',
        ft_motor_compre: 'Comprehensive Motor Insurance',

        ft_property: 'Property Insurance',
        ft_prop_home: 'Home Insurance',
        ft_prop_fire: 'Fire Insurance',
        ft_prop_burg: 'Burglary Insurance',
        ft_prop_shop: 'Shop Insurance',
        ft_prop_indus: 'Industrial Insurance',

        ft_travel: 'Travel Insurance',
        ft_travel_dom: 'Domestic Travel Insurance',
        ft_travel_intl: 'International Travel Insurance',
        ft_travel_stud: 'Student Travel Insurance',
        ft_travel_fam: 'Family Travel Insurance',

        ft_business: 'Business Insurance',
        ft_biz_liab: 'Liability Insurance',
        ft_biz_indem: 'Professional Indemnity Insurance',
        ft_biz_cyber: 'Cyber Insurance',
        ft_biz_marine: 'Marine Insurance',
        ft_biz_comp: 'Workmen Compensation Insurance',

        ft_others: 'Other Insurance',
        ft_oth_mobile: 'Mobile Insurance',
        ft_oth_gadget: 'Gadget Insurance',
        ft_oth_pet: 'Pet Insurance',
        ft_oth_crop: 'Crop Insurance',
        ft_oth_event: 'Event Insurance',
        ft_oth_wed: 'Wedding Insurance',
    },

    hi: {
        // Navbar
        nav_home: 'होम',
        nav_life: 'जीवन',
        nav_health: 'स्वास्थ्य',
        nav_motor: 'मोटर',
        nav_property: 'संपत्ति',
        nav_travel: 'यात्रा',
        nav_business: 'व्यापार',
        nav_insurance: 'बीमा',
        nav_about: 'हमारे बारे में',
        nav_contact: 'संपर्क',
        nav_get_started: 'शुरू करें',
        nav_search_placeholder: 'बीमा योजनाएं खोजें...',
        nav_branch: 'नई दिल्ली, भारत',
        nav_whatsapp: '+91 96671 93590',
        nav_phone: '+91 96671 93590',

        // Hero
        hero_badge: 'शीर्ष रेटेड · 2026',
        hero_title: 'स्मार्ट बीमा से अपना भविष्य सुरक्षित करें',
        hero_subtitle: 'अपने जीवन, स्वास्थ्य और संपत्ति के लिए अनुकूलित योजनाएं खोजें। उद्योग-अग्रणी दावा निपटान के साथ पारदर्शी कीमतों पर प्रीमियम कवरेज।',
        hero_trust: '2,00,000+ खुश पॉलिसीधारकों द्वारा विश्वसनीय',
        hero_btn_explore: 'कोट प्राप्त करें',
        hero_btn_quote: 'कोट प्राप्त करें',

        // Stats
        stat_1_num: '2L+',
        stat_1_label: 'खुश ग्राहक',
        stat_2_num: '99%',
        stat_2_label: 'दावा निपटान',
        stat_3_num: '₹500Cr+',
        stat_3_label: 'दावे चुकाए',
        stat_4_num: '50+',
        stat_4_label: 'बीमा योजनाएं',

        // Products Section
        products_eyebrow: 'हमारे उत्पाद',
        products_title: 'हर ज़रूरत के लिए बीमा योजनाएं',
        products_subtitle: 'आपके लिए सबसे ज़रूरी चीज़ों की सुरक्षा के लिए व्यापक कवरेज विकल्प।',
        product_life: 'जीवन बीमा',
        product_life_desc: 'हमारी व्यापक जीवन बीमा योजनाओं से अपने परिवार का भविष्य सुरक्षित करें।',
        product_health: 'स्वास्थ्य बीमा',
        product_health_desc: 'आपके और आपके प्रियजनों के लिए गुणवत्तापूर्ण स्वास्थ्य सेवा कवरेज।',
        product_motor: 'मोटर बीमा',
        product_motor_desc: 'आपके वाहन के लिए तेज़ दावा निपटान और विस्तृत गैराज नेटवर्क।',
        product_property: 'संपत्ति बीमा',
        product_property_desc: 'हमारी संपत्ति कवरेज से अपने घर और संपत्ति की रक्षा करें।',
        product_travel: 'यात्रा बीमा',
        product_travel_desc: 'मन की शांति और 24/7 सहायता के साथ दुनिया की यात्रा करें।',
        product_business: 'व्यापार बीमा',
        product_business_desc: 'अप्रत्याशित जोखिमों से अपने व्यापार की रक्षा करें।',
        product_others: 'अन्य',
        product_others_desc: 'आपके पालतू जानवरों, गैजेट्स और अन्य के लिए विशेष बीमा।',
        learn_more: 'और जानें',

        // How It Works
        hiw_eyebrow: 'सरल प्रक्रिया',
        hiw_title: 'यह कैसे काम करता है',
        hiw_subtitle: 'चार सरल चरणों में कवर हो जाएं — कोई कागजी कार्रवाई नहीं, कोई परेशानी नहीं।',
        hiw_step1: 'कोट अनुरोध',
        hiw_step1_desc: 'आपके लिए बनी बीमा योजनाओं की विस्तृत श्रृंखला ब्राउज़ करें।',
        hiw_step2: 'कोट प्राप्त करें',
        hiw_step2_desc: 'कुछ त्वरित प्रश्नों का उत्तर दें और तुरंत कोट पाएं।',
        hiw_step3: 'ऑनलाइन आवेदन करें',
        hiw_step3_desc: 'मिनटों में अपना आवेदन पूरा करें — पूरी तरह डिजिटल।',
        hiw_step4: 'सुरक्षित रहें',
        hiw_step4_desc: 'यह जानकर आराम करें कि आपका भविष्य पहले दिन से सुरक्षित है।',

        // Benefits
        benefits_eyebrow: 'InsureWise क्यों',
        benefits_title: 'विश्वास और पारदर्शिता पर निर्मित',
        benefits_subtitle: 'हम आपकी मन की शांति की वास्तविक सुरक्षा के लिए पॉलिसी दस्तावेज़ों से आगे जाते हैं।',
        benefit_1: '99% दावा निपटान',
        benefit_1_desc: 'दावों की प्रक्रिया में उद्योग-अग्रणी पारदर्शिता और गति।',
        benefit_2: '24/7 ग्राहक सहायता',
        benefit_2_desc: 'हमारे समर्पित सलाहकार हमेशा आपकी सहायता के लिए उपलब्ध हैं — कभी भी, कहीं भी।',
        benefit_3: 'कागज़रहित प्रक्रिया',
        benefit_3_desc: 'हमारे पूर्णतः डिजिटल और सहज ऑनबोर्डिंग अनुभव से मिनटों में बीमित हो जाएं।',

        // Testimonials
        testimonials_eyebrow: 'ग्राहक कहानियां',
        testimonials_title: 'हमारे ग्राहक क्या कहते हैं',
        testimonials_subtitle: 'InsureWise पर भरोसा करने वाले लोगों के वास्तविक अनुभव।',
        testimonial_1: 'InsureWise ने स्वास्थ्य कवरेज प्राप्त करना अविश्वसनीय रूप से सरल बना दिया। पूरी प्रक्रिया डिजिटल थी और मुझे 10 मिनट में मेरी पॉलिसी मिल गई।',
        testimonial_1_name: 'प्रिया शर्मा',
        testimonial_1_role: 'स्वास्थ्य योजना सदस्य',
        testimonial_2: 'उनकी 24/7 सपोर्ट टीम ने रात 2 बजे मोटर दावे में मेरी मदद की। असाधारण सेवा और तेज़ निपटान — सच में प्रभावित।',
        testimonial_2_name: 'राहुल वर्मा',
        testimonial_2_role: 'मोटर बीमा',
        testimonial_3: 'एक व्यापार मालिक के रूप में, सही कवरेज ढूंढना कठिन था। InsureWise के सलाहकारों ने धैर्य से हर विकल्प समझाया।',
        testimonial_3_name: 'अनिता देसाई',
        testimonial_3_role: 'व्यापार बीमा',

        // CTA
        cta_title: 'जो ज़रूरी है उसकी रक्षा के लिए तैयार?',
        cta_subtitle: '2 लाख+ ग्राहकों से जुड़ें जिन्होंने स्मार्ट बीमा चुना। 2 मिनट से कम में व्यक्तिगत कोट पाएं।',
        cta_btn_primary: 'शुरू करें',
        cta_btn_secondary: 'योजनाएं देखें',

        // Contact Page
        contact_hero_title: 'हम आपकी मदद के लिए यहां हैं',
        contact_hero_subtitle: 'हमारी योजनाओं के बारे में प्रश्न हैं? हमारे विशेषज्ञ बस एक संदेश दूर हैं। आइए मिलकर आपका भविष्य सुरक्षित करें।',
        contact_title: 'संपर्क करें',
        contact_subtitle: 'इनमें से किसी भी चैनल के माध्यम से संपर्क करें या फॉर्म भरें।',
        contact_email_title: 'ईमेल करें',
        contact_call_title: 'कॉल करें',
        contact_visit_title: 'हमारे कार्यालय पर आएं',
        contact_hours_title: 'कार्यालय समय',
        contact_hours_mf: 'सोमवार - शुक्रवार',
        contact_hours_sat: 'शनिवार',
        contact_hours_sun: 'रविवार',
        contact_hours_mf_time: '9:00 AM - 6:00 PM',
        contact_hours_sat_time: '10:00 AM - 2:00 PM',
        contact_hours_sun_time: 'बंद',
        contact_form_name: 'पूरा नाम',
        contact_form_email: 'ईमेल पता',
        contact_form_phone: 'फ़ोन नंबर',
        contact_form_subject: 'विषय',
        contact_form_message: 'हम कैसे मदद कर सकते हैं?',
        contact_form_submit: 'संदेश भेजें',
        contact_form_sending: 'भेज रहे हैं...',
        contact_form_note: 'हमारी टीम आमतौर पर 4 कार्य घंटों में जवाब देती है।',
        contact_form_placeholder_name: 'अपना नाम दर्ज करें',
        contact_form_placeholder_email: 'you@email.com',
        contact_form_placeholder_phone: '99999xxxxx',
        contact_form_placeholder_message: 'अपनी बीमा ज़रूरतों के बारे में बताएं...',
        contact_option_general: 'सामान्य पूछताछ',
        contact_option_claims: 'दावा सहायता',
        contact_option_agent: 'एजेंट परामर्श',
        contact_option_policy: 'पॉलिसी अपडेट',
        contact_success_title: 'संदेश भेजा गया!',
        contact_success_text: 'संपर्क करने के लिए धन्यवाद। हमारे बीमा विशेषज्ञ जल्द ही आपसे संपर्क करेंगे।',
        contact_success_btn: 'एक और संदेश भेजें',

        // Footer
        footer_brand_text: '1995 से प्रीमियम बीमा समाधान प्रदान कर रहे हैं। आपकी सुरक्षा हमारी प्राथमिकता है।',
        footer_company: 'कंपनी',
        footer_about: 'हमारे बारे में',
        footer_careers: 'करियर',
        footer_contact: 'संपर्क करें',
        footer_blog: 'ब्लॉग',
        footer_insurance_types: 'बीमा प्रकार',
        footer_support: 'सहायता',
        footer_copyright: '© {year} Bharatinsurex. सर्वाधिकार सुरक्षित।',

        // Extended Insurance Categories
        ft_life: 'जीवन बीमा',
        ft_life_term: 'टर्म इंश्योरेंस',
        ft_life_whole: 'होल लाइफ इंश्योरेंस',
        ft_life_endow: 'बंदोबस्ती योजना',
        ft_life_money: 'मनी बैक प्लान',
        ft_life_ulip: 'यूलिप (यूनिट लिंक्ड बीमा योजना)',
        ft_life_child: 'चाइल्ड इंश्योरेंस प्लान',
        ft_life_pension: 'पेंशन योजना',

        ft_health: 'स्वास्थ्य बीमा',
        ft_health_indiv: 'व्यक्तिगत स्वास्थ्य बीमा',
        ft_health_family: 'फैमिली फ्लोटर इंश्योरेंस',
        ft_health_critical: 'क्रिटिकल इलनेस इंश्योरेंस',
        ft_health_senior: 'वरिष्ठ नागरिक स्वास्थ्य बीमा',
        ft_health_group: 'ग्रुप हेल्थ इंश्योरेंस',
        ft_health_accident: 'व्यक्तिगत दुर्घटना बीमा',

        ft_motor: 'मोटर बीमा',
        ft_motor_car: 'कार इंश्योरेंस',
        ft_motor_bike: 'टू-व्हीलर इंश्योरेंस',
        ft_motor_comm: 'वाणिज्यिक वाहन बीमा',
        ft_motor_third: 'थर्ड-पार्टी इंश्योरेंस',
        ft_motor_compre: 'व्यापक मोटर बीमा',

        ft_property: 'संपत्ति बीमा',
        ft_prop_home: 'होम इंश्योरेंस',
        ft_prop_fire: 'अग्नि बीमा',
        ft_prop_burg: 'सेंधमारी बीमा',
        ft_prop_shop: 'दुकान बीमा',
        ft_prop_indus: 'औद्योगिक बीमा',

        ft_travel: 'यात्रा बीमा',
        ft_travel_dom: 'घरेलू यात्रा बीमा',
        ft_travel_intl: 'अंतरराष्ट्रीय यात्रा बीमा',
        ft_travel_stud: 'छात्र यात्रा बीमा',
        ft_travel_fam: 'पारिवारिक यात्रा बीमा',

        ft_business: 'व्यापार बीमा',
        ft_biz_liab: 'देयता बीमा',
        ft_biz_indem: 'व्यावसायिक क्षतिपूर्ति बीमा',
        ft_biz_cyber: 'साइबर बीमा',
        ft_biz_marine: 'समुद्र बीमा',
        ft_biz_comp: 'कामगार मुआवजा बीमा',

        ft_others: 'अन्य बीमा',
        ft_oth_mobile: 'मोबाइल बीमा',
        ft_oth_gadget: 'गैजेट बीमा',
        ft_oth_pet: 'पालतू पशु बीमा',
        ft_oth_crop: 'फसल बीमा',
        ft_oth_event: 'इवेंट इंश्योरेंस',
        ft_oth_wed: 'वेडिंग इंश्योरेंस',
    },
};

/* ═══════════════════════════════════════════════════ */

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
    const [lang, setLang] = useState('en');

    const t = useCallback((key) => {
        return translations[lang]?.[key] || translations['en']?.[key] || key;
    }, [lang]);

    const toggleLang = useCallback(() => {
        setLang(prev => prev === 'en' ? 'hi' : 'en');
    }, []);

    const setLanguage = useCallback((newLang) => {
        if (translations[newLang]) setLang(newLang);
    }, []);

    return (
        <LanguageContext.Provider value={{ lang, t, toggleLang, setLanguage }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (!context) throw new Error('useLanguage must be used within LanguageProvider');
    return context;
};

export default LanguageContext;
